/**
 * Labstep
 */

import { keymap } from 'prosemirror-keymap';
import {
  columnResizing,
  goToNextCell,
  tableEditing,
} from 'prosemirror-tables';
import { TableHandlesPlugin } from './table-handles';

// Create table handles plugin instance
const tableHandlesPlugin = new TableHandlesPlugin();

const plugins = [
  tableEditing(),
  columnResizing({}),
  keymap({
    Tab: goToNextCell(1),
    'Shift-Tab': goToNextCell(-1),
  }),
  tableHandlesPlugin.createPlugin(),
];

// Export the plugin instance for use in React components
export { tableHandlesPlugin };
export default plugins;
